import { diInject } from "stores/diContext";
import { EventService } from "../services/events";

import { EventStore } from "./events";
import { CartStore } from "./cart";

import * as _ from "lodash";

import { observable, computed } from "mobx";

/**
 * 票列表项Store
 */
export class TicketItemStore {
  @diInject() eventStore: EventStore;
  @diInject() cartStore: CartStore;

  constructor(public ticket: ITicketResult) {
    this.id = ticket.id;
    this._init();
  }

  id;
  //是否rsvp票类，原始金额为0
  isRsvp = this.ticket.amount == 0;
  //票类数量
  @observable count = 0;
  //是否可添加票
  @computed get canAdd() {
    return this.getAddCount(false) > 0;
  }
  //是否能移除票
  @computed get canRemove() {
    return this.count > 0;
  }

  //票类当前金额
  @computed get amount() {
    var ticket = this.ticket;
    if (this.discount_id != "0") {
      if (this.discount_ticket) {
        ticket = this.discount_ticket;
      }
    }
    return ticket.amount;
  }

  //票类优惠金额
  @observable discount_amount = 0;

  //票类显示价格
  @computed get price() {
    let price = Math.max(this.ticket.price - this.discount_amount, 0);
    return price;
  }

  //票类总金额
  @computed get total_amount() {
    return this.amount * this.count;
  }
  //票类原始价格
  @computed get raw_total_amount() {
    return this.ticket.amount * this.count;
  }

  //优惠后的手续费
  @observable discount_fee = 0;

  //优惠码ID
  @observable discount_id = "0";

  //优惠码是否显示隐藏的关联票
  @observable is_reveal_ticket_by_discount = false;

  //手续费
  @computed get fee() {
    var ticket = this.ticket;
    if (this.discount_id != "0") {
      if (this.discount_ticket) {
        ticket = this.discount_ticket;
      }
    }
    var {
      merchant_fee,
      payment_method_additional_fee,
      payment_method_additional_fix_fee,
      sparxo_fee,
    } = ticket;
    let fee = merchant_fee;
    if (this.ticket.fee_type == "ExcludeFee") {
      fee =
        merchant_fee +
        payment_method_additional_fee +
        payment_method_additional_fix_fee +
        sparxo_fee;
    }
    return fee;
  }

  //使用折扣码后的票信息
  discount_ticket;

  //税费
  @computed get tax() {
    var fee = this.ticket.tax;
    if (this.discount_id != "0") {
      if (this.ticket.tax_use_percentage) {
        var fee =
          (this.discount_ticket.price - this.discount_ticket.discount_amount) *
          (this.ticket.tax_percentage / 100);
        return Math.round(fee);
      } else {
        fee = this.discount_ticket.tax;
        return fee;
      }
    } else {
      if (this.ticket.tax_use_percentage) {
        return this.ticket.price * (this.ticket.tax_percentage / 100);
      }
    }
    return fee;
  }

  //是否在销售时间范围之中
  in_sell_time = true;

  //距离开始时间分钟数
  leftBeginTimeMinutes = 0;
  leftTimeValue = 0;
  leftTimeMax = 100;
  leftTimeUnit = "day";

  @computed get is_visible() {
    if (!this.ticket.is_active) {
      return false;
    }
    // if (this.ticket.is_need_code_to_show && !this.is_reveal_ticket_by_discount) {
    //     return false;
    // }
    return this.in_sell_time;
  }

  //是否sold_out
  get sold_out() {
    return this.getRemainQuantity() == 0;
  }
  //当前余票
  get quantity() {
    return this.eventStore.ticketsStore.getRemainQuantity(this).quantity;
  }

  private _init() {
    var begin_time_utc = this.ticket.sale_begin_time_utc,
      end_time_utc = this.ticket.sale_end_time_utc;
    var now = new Date(this.eventStore.utcNow).getTime();
    var btime = new Date(begin_time_utc).getTime();
    var etime = new Date(end_time_utc).getTime();
    if (btime - now > 0) {
      this.in_sell_time = false;
    }
    if (now - etime > 0) {
      this.in_sell_time = false;
    }
    //Get the number of minutes since the start time
    this.leftBeginTimeMinutes = (btime - now) / (1000 * 60);
    var timespan = etime - now;
    var leftHours = Math.floor(timespan / (3600 * 1000));

    if (leftHours > 48) {
      this.leftTimeUnit = "day";
      this.leftTimeValue = Math.floor(leftHours / 24);
      this.leftTimeMax = Math.max(90, this.leftTimeValue);
    } else {
      this.leftTimeUnit = "hour";
      this.leftTimeValue = leftHours;
      this.leftTimeMax = 48;
    }
  }

  /**
   * Get the number of tickets that can be added
   * @param is_add_default_quantity Does it contain default_quantity
   */
  private getAddCount(is_add_default_quantity = true) {
    const remain_quantity_obj = this.eventStore.ticketsStore.getRemainQuantity(
      this,
      true
    );
    const remain_quantity = remain_quantity_obj.quantity;
    const selected_quantity = this.cartStore.allCount;

    let add_count = 1;

    if (this.count == 0) {
      add_count = this.ticket.order_min_quantity || 1;

      if (is_add_default_quantity && this.__is_first_add_ticket) {
        let default_quantity = this.ticket.default_ticket_quantity || 0;

        if (default_quantity > remain_quantity) {
          default_quantity = 0;
        }

        if (default_quantity + selected_quantity > __MAX_ORDER_COUNT__) {
          default_quantity = 0;
        }

        add_count = default_quantity;

        this.__is_first_add_ticket = false;
      }
    }

    if (this.count + add_count > remain_quantity) {
      if (remain_quantity_obj.code == 1) {
        return -4;
      }
      return -1;
    }

    if (add_count + selected_quantity > __MAX_ORDER_COUNT__) {
      return -2;
    }

    if (this.count + add_count > this.ticket.order_max_quantity) {
      return -3;
    }

    return add_count;
  }

  //Whether to add a ticket for the first time（default_quantity）
  private __is_first_add_ticket = true;

  /**
   * Try adding a default number of tickets
   */
  tryAddDefaultQuantity() {
    if (this.__is_first_add_ticket) {
      this.add();
    }
  }

  /**
   *Try to add a ticket, return status, 
   -1: Insufficient remaining tickets, 
   -2: Exceed the maximum total number of system orders,
   -3: Exceed the maximum number of user-configured orders.
   */
  add() {
    if (!this.is_visible) {
      return 0;
    }
    const add_count = this.getAddCount();

    if (add_count > 0) {
      let added_count = 0;
      for (let i = 0; i < add_count; i++) {
        added_count = this.cartStore.addTicket(this);
      }
      this.count = added_count;
      return this.count;
    }
    return add_count;
  }

  //TODO: refactor
  addFromSelect() {
    if (!this.is_visible) {
      return 0;
    }
    var add_count = this.getAddCount();
    if (add_count > 0) {
      var added_count = 0;
      added_count = this.cartStore.addTicket(this);
      this.count = added_count;
      return this.count;
    }
    return add_count;
  }

  /**
   * Try to remove a ticket
   */
  remove() {
    if (this.canRemove) {
      var del_count = 1;
      if (this.count == this.ticket.order_min_quantity) {
        del_count = this.count;
      }
      this.count = this.cartStore.removeTicket(this.id, del_count);
    }
  }

  /**
   * Clear discount code information
   */
  clearPromoCode() {
    this.discount_code = null;
    this.discount_amount = 0;
    this.discount_ticket = null;
    this.discount_id = "0";
  }

  discount_code: ICouponCodesResult;

  /**
   * Use discount code
   * @param code
   * @param ticket
   */
  applyPromoCode(code: ICouponCodesResult, ticket) {
    if (code.is_reveal_ticket) {
      this.is_reveal_ticket_by_discount = true;
      this.tryAddDefaultQuantity();
    }
    if (code.is_enable_limitation_times) {
      const code_ticket_count =
        this.eventStore.ticketsStore.getTicketCountByDiscountCode(code.id);
      if (code_ticket_count + this.count > code.can_use_times) {
        return false;
      }
    }

    this.discount_code = code;
    this.discount_amount = ticket.discount_amount;
    this.discount_ticket = ticket;
    this.discount_id = code.id;
    return true;
  }

  /**
   * Get current inventory
   */
  getRemainQuantity() {
    return this.quantity;
  }
}

export class TicketsStore {
  @diInject() eventService: EventService;
  @diInject() eventStore: EventStore;

  @observable tickets: Array<TicketItemStore> = [];

  isOver = false;
  isNotStarted = false;
  leftBeginTimeMinutes = 0;

  visibleCount() {
    return this.tickets.filter((t) => {
      if (t.is_visible) {
        return true;
      }
      return t.in_sell_time && t.ticket.is_need_code_to_show;
    }).length;
  }

  /**
   * Load remaining ticket information
   */
  async loadTicketSoldInfo(filter?: { ticket }) {
    const { event } = this.eventStore;
    const ticketsResult = await this.eventService.getTicketsCheck(
      event.id,
      event.schedules[0].id
    );

    var tickets = ticketsResult.visible_tickets;

    tickets.sort((left, right) => {
      return left.placement_index - right.placement_index;
    });
    const stores = [];
    //If ticket sales have not started, the time when ticket sales will start
    const notStartedTimes = [];

    console.log("### tickets count", tickets.length);

    for (let ticket of tickets) {
      if (filter && filter.ticket) {
        if (ticket.id != filter.ticket) {
          continue;
        }
      }
      //First, the ticket must be open
      if (ticket.is_active) {
        //If the ticket does not set its own ticket sales time, the start time is set to the current time and the end time is set to the event end time
        if (!ticket.is_set_sale_time) {
          ticket.sale_begin_time_utc = this.eventStore.utcNow;
          ticket.sale_end_time_utc =
            this.eventStore.event.schedules[0].end_time_utc;
        }
        var store = new TicketItemStore(ticket);
        //Add ticket to list
        stores.push(store);
        //If the ticket has not started, the difference between the ticket start time and the current time is added to the temporary list.
        if (store.leftBeginTimeMinutes > 0) {
          notStartedTimes.push(store.leftBeginTimeMinutes);
        }
      }
    }
    this.tickets = stores;
    this.isNotStarted = false;
    this.isOver = false;
    //If the ticket list is empty
    if (this.visibleCount() == 0) {
      //Determine whether there are unstarted tickets
      if (notStartedTimes.length > 0 || ticketsResult.has_future_sale_time) {
        this.isNotStarted = true;
        //The time difference between the most recently started tickets
        this.leftBeginTimeMinutes =
          notStartedTimes.length > 0
            ? Math.min(...notStartedTimes)
            : ticketsResult.left_begin_minutes;
      } else if (
        ticketsResult.total_tickets_count == 0 ||
        !ticketsResult.has_vip_codes
      ) {
        //Otherwise, when the ticket sales process has ended and don't have hidden tickets
        this.isOver = true;
      }
    }

    return this.tickets;
  }

  async loadVipTicketSoldInfo(tickets: any) {
    const stores = this.tickets;

    const notStartedTimes = [];

    for (let ticket of tickets) {
      if (!ticket.is_set_sale_time) {
        ticket.sale_begin_time_utc = this.eventStore.utcNow;
        ticket.sale_end_time_utc =
          this.eventStore.event.schedules[0].end_time_utc;
      }

      const alreadyExist =
        _.findIndex(stores, (t) => t.id === ticket.id) !== -1;

      if (!alreadyExist) {
        const store = new TicketItemStore(ticket);

        stores.push(store);

        if (store.leftBeginTimeMinutes > 0) {
          notStartedTimes.push(store.leftBeginTimeMinutes);
        }
      }
    }

    stores.sort((left, right) => {
      return left.ticket.placement_index - right.ticket.placement_index;
    });

    this.tickets = stores;
    this.isNotStarted = false;
    this.isOver = false;

    if (this.visibleCount() == 0) {
      if (notStartedTimes.length > 0) {
        this.isNotStarted = true;
        this.leftBeginTimeMinutes = Math.min(...notStartedTimes);
      } else {
        this.isOver = true;
      }
    }

    this.tryAddDefaultQuantity();

    return this.tickets;
  }

  getTicketCountByDiscountCode(code_id) {
    var count = 0;
    for (var store of this.tickets) {
      if (store.discount_id == code_id) {
        count += store.count;
      }
    }
    return count;
  }

  /**
   * To obtain the remaining tickets of a ticket type, you need to determine whether to limit the total number of tickets sold.
   * @param ticket
   * @param include_selected_quantity，Whether to include the number of other tickets that have been selected
   *quantity:Get the number of remaining votes that may be restricted, 
             code=1, The number of tickets purchased is limited by the discount code,
             code=2 The number of tickets purchased is limited by the total number
   */
  getRemainQuantity(
    ticket: TicketItemStore,
    include_selected_quantity = false
  ) {
    const { event } = this.eventStore;
    const { is_set_tickets_total_capacity, tickets_total_capacity } = event;
    let {
      current_inventory: { stock_quantity, reserved_quantity },
    } = ticket.ticket;

    let code = 0;

    if (
      ticket.discount_code &&
      ticket.discount_code.is_enable_limitation_times
    ) {
      var stock_quantity_with_discount_code = Math.min(
        stock_quantity,
        ticket.discount_code.can_use_times
      );
      if (include_selected_quantity) {
        for (const store of this.tickets) {
          if (store.id == ticket.id) {
            continue;
          }
          if (store.discount_code && store.discount_id == ticket.discount_id) {
            stock_quantity_with_discount_code =
              stock_quantity_with_discount_code - store.count;
          }
        }
      }
      if (stock_quantity_with_discount_code < stock_quantity) {
        code = 1;
        stock_quantity = stock_quantity_with_discount_code;
      }
    }
    //余票等于当前余票减去预留票的数量
    let quantity = stock_quantity - reserved_quantity;
    if (is_set_tickets_total_capacity) {
      //统计已销售的票的总数
      var sold_quantity = 0;

      for (const store of this.tickets) {
        const temp_ticket = store.ticket;
        sold_quantity +=
          temp_ticket.stock_quantity -
          temp_ticket.current_inventory.stock_quantity;
        if (include_selected_quantity && store.id != ticket.id) {
          sold_quantity += store.count;
        }
      }
      let total_quantity = tickets_total_capacity - sold_quantity;
      if (total_quantity < 0) {
        total_quantity = 0;
      }
      if (total_quantity < quantity) {
        code = 2;
      }
      quantity = Math.min(total_quantity, quantity);
    }
    return {
      code,
      quantity,
    };
  }

  tryAddDefaultQuantity() {
    for (let ticket of this.tickets) {
      if (ticket.is_visible) {
        ticket.tryAddDefaultQuantity();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/Apps/ticketing/stores/ticket.ts